// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".G8t1oCquKpJtr3DE10sFe {\n  padding: 0 0.5rem 0.5rem;\n}\n._3Fjj8iFuI5Fh6s3syPtzc1 {\n  overflow: auto;\n}\n", ""]);
// Exports
exports.locals = {
	"details": "G8t1oCquKpJtr3DE10sFe",
	"code-editor": "_3Fjj8iFuI5Fh6s3syPtzc1",
	"codeEditor": "_3Fjj8iFuI5Fh6s3syPtzc1"
};
module.exports = exports;
